"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("../Themes/styled-components"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  margin-top: ", ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  font-size: ", ";\n  margin-top: ", ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])), polished_1.rem(14), polished_1.rem(2));
var Breadcrumb = styled_components_1.default('span')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  a {\n    cursor: pointer;\n    color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  color: ",
    ";\n  a {\n    cursor: pointer;\n    color: ",
    ";\n    text-decoration: none;\n  }\n"])), function (_a) {
    var theme = _a.theme, active = _a.active;
    return active ? theme.textColor : theme.inactiveColor;
}, function (_a) {
    var theme = _a.theme, active = _a.active;
    return active ? theme.textColor : theme.inactiveColor;
});
var Breadcrumbs = /** @class */ (function (_super) {
    __extends(Breadcrumbs, _super);
    function Breadcrumbs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Breadcrumbs.prototype.render = function () {
        var crumbs = this.props.crumbs;
        var numberOfCrumbs = crumbs.length;
        if (numberOfCrumbs === 0) {
            return null;
        }
        return (React.createElement(Wrapper, null, crumbs.map(function (crumb, idx) { return (React.createElement(Breadcrumb, { key: idx.toString(), active: idx === numberOfCrumbs - 1 },
            crumb,
            idx !== numberOfCrumbs - 1 && ' / ')); })));
    };
    return Breadcrumbs;
}(React.PureComponent));
exports.default = Breadcrumbs;
var templateObject_1, templateObject_2;
